<template>
  <div id="Work">

    <div ref="loading_cover" class="loading-cover"><div class="center-spin"><b-spinner variant="danger" label="Spinning"></b-spinner></div></div>

    <bg-pattern-div :imgSrc="patternImgSrc" zIndex="-99" :opacity="opacity_bg"></bg-pattern-div>
    <div class="more-btn" @click="shareWorks" title="share works" style="display: block;"><img src="@/static/images/share_btn.png" alt="share works"></div>
    
    <section class="work-section">
      <img-item ref="top_img" :imgItemSrc="topImgObj"></img-item>
      <div class="title">{{ projectName }}</div>
      <div class="container list">
          <div class="row justify-content-center">
            <template v-for="(c, index) in categoriesChoose" >
                  <div class="col-md-auto fit-content" :id="c.pk" :key="index"><button @click="categoryOnClick" class="c-btn">{{c.fields.category_name}}</button></div>
              </template>
          </div>
      </div>
    </section>

    <section class="about-project-section">
      <div class="container">
        <div class="row justify-content-md-center">
          <div class="col-md-8">
            <p v-html="aboutProjectContent" class="about-project">
            </p>
          </div>
        </div>  
      </div>
    </section>

    <section class="youtube-project-section">
      <div v-show="showYoutube" class="container list"> 
          <div class="row justify-content-around">
           <div class="list-img-youtube-div-large">
              <div class="youtubeDiv"><iframe class="youtube" :src="youbueLink" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe></div>
            </div>
          </div>
      </div>
    </section>

     <section class="pic-project-section">
      <div class="container list"> 
        <div class="row justify-content-around">
          
          <list-item-large v-for="(pic) in picsData" :itemTitle="pic.imgTitle" :itemImgSrc="pic" :key="pic.photoID"></list-item-large>
        </div>
      </div>
    </section>

     <section ref="footer-project" class="footer-project-section">
      <div class="container">
        <div class="row justify-content-md-center">
          <div class="col-md-8">
            <p v-html="footerProjectContent" class="footer-project">
            </p>
          </div>
        </div>  
      </div>
    </section>

  </div>
</template>

<script>

import BgPatternDiv from "../components/BgPatternDiv.vue"
import ImgItem from "../components/ImgItem.vue"
import ListItemLarge from "../components/ListItemLarge.vue"
const gcs_host = "https://storage.googleapis.com/sb_web_site/";
const axios = require('axios').default;
var hostName = "";
//const hostNuame = location.hostname; 
var api_host = "https://" + hostName + "/admin/api/";
var api_get_project_info = api_host + "project_info/";
var api_get_categories = api_host + "get_categories";

export default {
  name: 'Work',
  components: {
    //FullVideoDiv,
    BgPatternDiv,
    ImgItem,
    ListItemLarge,

  },
  data(){
          return {
            
            projectObj: null,
            projectName: "",
            categoriesDict: {},
            categories: null,
            categoriesChoose: [],
            patternImgSrc:"../assets/bg_pattern.jpg",
            opacity_bg: 1,
            aboutProjectContent: 'hihihihi',
            aboutProjectContentTrim: '',
            footerProjectContent: 'hihihi',
            editResultDataObj: null,
            topImgObj: null,
            topImgURL: "",
            coverImgObj: null,
            imgDataDict: null,
            isShowYoutube :false,
            youbueLink:'',
            picsData: [],
            


          }
  },
  metaInfo(){

    return{
      title: this.projectName + '-路人甲影像',
      meta: [
                {charset: 'utf-8'}, 
                {name: 'viewport', content: 'width=device-width, initial-scale=1, maximum-scale=1, user-scalable=0' },
                {name: 'description', content: this.aboutProjectContentTrim},
                {property: 'og:title', content: this.projectName + '-路人甲影像'},
                {property: 'og:site_name', content: '路人甲影像'},
                {property: 'og:description', content: this.aboutProjectContentTrim},
                {property: 'og:type', content: 'website'},
                {property: 'og:url', content: window.location.href},
                {property: 'og:image', content: this.topImgURL }    
            ]
    }

  },
  methods:{
    shareWorks:function(){
      //https://www.facebook.com/sharer/sharer.php?u=
      
      var shareLink = 'https://www.facebook.com/sharer/sharer.php?u=' + window.location.href;
      window.open(shareLink, '_blank');
    },
    hideCover:function(){
      this.$refs.loading_cover.className = "loading-cover finish";
    }
   
  },
  
  computed:{
    
    showYoutube : function(){
      return this.isShowYoutube;
    }
    
  },

  created(){

    hostName = this.$apiHost;
    //const hostNuame = location.hostname; 
    api_host = "https://" + hostName + "/admin/api/";
    api_get_project_info = api_host + "project_info/";
    api_get_categories = api_host + "get_categories";


  },
  mounted() {
    
    
    this.$nextTick(()=>{
      
      let self = this;
      let projectID = this.$route.params.pID;
      this.$emit('onViewReady', this.$route.name);
      api_get_project_info = api_host + "project_info/";
      api_get_project_info = api_get_project_info + projectID;
      //console.log(api_get_project_info);

     axios
          .get(api_get_categories)
          .then((response) => {
              let response_data = response.data;
              //console.log(response_data);
              self.categories = response_data.categories;
              
              for(var i = 0 ; i < response_data.categories.length ; i++){
                var cateDataObj = response_data.categories[i];
                self.categoriesDict[cateDataObj.pk] = cateDataObj.fields.category_name;

              }

               axios
              .get(api_get_project_info)
              .then((response) => {
                  let response_data = response.data;
                  self.projectObj = response_data.project_info[0];
                  self.projectName = self.projectObj.fields.project_name;
                  //console.log(self.projectObj);

                  self.aboutProjectContent = self.projectObj.fields.project_desc.replace(/\r\n/g, "<br />");
                  self.footerProjectContent = self.projectObj.fields.project_footer.replace(/\r\n/g, "<br />");
                  self.aboutProjectContentTrim = self.aboutProjectContent.replace("<br />", "");
                  self.editResultDataObj = JSON.parse(self.projectObj.fields.project_edit_result);
                  self.imgDataDict = self.editResultDataObj.picData;
                  
                  //console.log(self.imgDataDict);
                  
                  
                  let isTop = self.editResultDataObj.isTop;
                  let isCover = self.editResultDataObj.isCover;
                  self.topImgObj = self.imgDataDict[isTop];
                  self.$refs.top_img.getImgURL(self.topImgObj.fileName);
                  self.topImgURL = gcs_host + self.topImgObj.fileName;
                  //=====================
                  //console.log("====================================");
                  //console.log(self.imgDataDict);
                  delete self.imgDataDict[isTop];
                  //console.log(self.imgDataDict);

                  Object.keys(self.imgDataDict).forEach(function(key) {
                      self.picsData.push(self.imgDataDict[key])
                      //console.log(key, self.imgDataDict[key]);
                  });
                  //console.log(self.picsData);

                  self.picsData = self.picsData.reverse();
                 

                  self.coverImgObj = self.imgDataDict[isCover];
                  if(self.projectObj.fields.project_video_link != ""){
                    self.youbueLink = "https://www.youtube.com/embed/" + self.projectObj.fields.project_video_link;
                    self.isShowYoutube = true;
                  }else{
                    self.isShowYoutube = false;
                    self.youbueLink = "";
                  }

                  

                  for(var i = 0 ; i < self.categories.length ; i++){
                    var cateDataObj = self.categories[i];
                    
                    for(var j = 0 ; j < self.projectObj.fields.project_categories.length ; j++){

                      var caChoose = self.projectObj.fields.project_categories[j];
                      if(caChoose == cateDataObj.pk){
                        self.categoriesChoose.push(cateDataObj);
                      }
                      

                    }

                  }
                  
                  setTimeout(self.hideCover,1500);
                  window.scrollTo(0, 0);
                      
              })


          });


     




      
    });
   
    
    
  },
}
</script>

<style lang="sass" scoped>
  @import '../assets/work.sass'
</style>
